const TEAMS = [
  {
    name: "Flames",
    frName: "Flames",
    fullName: "Calgary Flames",
    homeTeamSlug: "calgary-flames",
    type: "NHL",
    zones: ["Press Level", "Second Level", "Lower Bowl"],
    colors: {
      attribute: "#D42604",
      background: "rgba(212,38,4,0.3)",
    },
    category: 'Teams',
  },
  {
    name: "Jets",
    frName: "Jets",
    fullName: "Winnipeg Jets",
    homeTeamSlug: "winnipeg-jets",
    type: "NHL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#004c97",
      background: "rgba(0, 76, 151, 0.3)",
    },
    category: 'Teams',
  },
  {
    name: "Oilers",
    frName: "Oilers",
    fullName: "Edmonton Oilers",
    homeTeamSlug: "edmonton-oilers",
    type: "NHL",
    zones: ["Upper Bowl", "Lower Bowl", "Premium Zone"],
    colors: {
      attribute: "#FF4B00",
      background: "rgba(255,75,0,0.3)",
    },
    category: 'Teams',
  },
  {
    name: "Canucks",
    frName: "Canucks",
    fullName: "Vancouver Canucks",
    homeTeamSlug: "vancouver-canucks",
    type: "NHL",
    zones: ["Upper Bowl", "Lower Bowl", "Club Lower"],
    colors: {
      attribute: "#008852",
      background: "rgba(0,136,82,0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Maple Leafs",
    frName: "Maple Leafs",
    fullName: "Toronto Maple Leafs",
    homeTeamSlug: "toronto-maple-leafs",
    type: "NHL",
    zones: ["Upper Zone", "Lower Zone", "Suites"],
    colors: {
      attribute: "#001b5a",
      background: "rgba(0,27,90,0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      107: '*', 108: '*', 109: '*',
      118: '*', 119: '*', 120: '*',
      308: '*', 309: '*', 310: '*',
      320: '*', 321: '*', 322: '*',
    },
    bypassPreferredForSets: [2, 3, 4],
  },
  {
    name: "Senators",
    frName: "Sénateurs",
    fullName: "Ottawa Senators",
    homeTeamSlug: "ottawa-senators",
    type: "NHL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#b79257",
      background: "rgba(183,146,87,0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    bypassPreferredForSets: [2, 3, 4],
  },
  {
    name: "Canadiens",
    frName: "Canadiens",
    fullName: "Montreal Canadiens",
    homeTeamSlug: "montreal-canadiens",
    type: "NHL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#AC1F2D",
      background: "rgba(172,31,45,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    bypassPreferredForSets: [2, 3, 4],
  },
  {
    name: "Raptors",
    frName: "Raptors",
    fullName: "Toronto Raptors",
    homeTeamSlug: "toronto-raptors",
    type: "NBA",
    zones: ["Upper Zone", "Lower Zone", "Premium Zone"],
    colors: {
      attribute: "#7637bf",
      background: "rgba(118,55,191,0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      107: '*', 108: '*', 109: '*',
      118: '*', 119: '*', 120: '*',
      308: '*', 309: '*', 310: '*',
      320: '*', 321: '*', 322: '*',
    },
    bypassPreferredForSets: [2, 3, 4],
  },
  {
    name: "Blue Jays",
    frName: "Blue Jays",
    fullName: "Toronto Blue Jays",
    homeTeamSlug: "toronto-blue-jays",
    type: "MLB",
    zones: ["Upper 500s", "Middle & Outfield", "Premium"],
    colors: {
      attribute: "#002d5f",
      background: "rgba(0,45,95,0.1)",
    },
    category: 'Teams',
    minSeats: 1,
    // tierLimits: {
    //   "1": 5,
    //   "2": 5,
    //   "3": 10,
    // }
  },
  {
    name: "Stampeders",
    frName: "Stampeders",
    fullName: "Calgary Stampeders",
    homeTeamSlug: "calgary-stampeders",
    type: "CFL",
    zones: ["Lower Zone", "Other", "-"],
    colors: {
      attribute: "#d60000",
      background: "rgba(214,0,0,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      E: [1,2,3,4,5,6],
      F: [1,2,3,4,5,6],
      G: [1,2,3,4,5,6],
      R: [1,2,3,4,5,6],
      S: [1,2,3,4,5,6],
      T: [1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Elks",
    frName: "Elks",
    fullName: "Edmonton Elks",
    homeTeamSlug: "edmonton-elks",
    type: "CFL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#2B5134",
      background: "rgba(43,81,52,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      E:[1,2,3,4,5,6],
      F:[1,2,3,4,5,6],
      G:[1,2,3,4,5,6],
      H:[1,2,3,4,5,6],
      I:[1,2,3,4,5,6],
      R:[1,2,3,4,5,6],
      S:[1,2,3,4,5,6],
      T:[1,2,3,4,5,6],
      U:[1,2,3,4,5,6],
      V:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Blue Bombers",
    frName: "Blue Bombers",
    fullName: "Winnipeg Blue Bombers",
    homeTeamSlug: "winnipeg-blue-bombers",
    type: "CFL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#1D3D7A",
      background: "rgba(29,61,122,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      207: '*',
      208: '*',
      209: '*',
      229: '*',
      230: '*',
      231: '*',
      105: '*',
      106: '*',
      107: '*',
      108: '*',
      109: '*',
      110: '*',
      127: '*',
      128: '*',
      129: '*',
      130: '*',
      131: '*',
      207: '*', 
      208: '*', 
      209: '*', 
      223: '*', 
      224: '*', 
      225: '*', 
      226: '*', 
      227: '*', 
      228: '*', 
      229: '*', 
      230: '*', 
      231: '*', 
      232: '*', 
      233: '*', 
      234: '*',
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Lions",
    frName: "Lions",
    fullName: "BC Lions",
    homeTeamSlug: "bc-lions",
    type: "CFL",
    zones: ["Upper Zone", "Club Seats", "Lower Zone"],
    colors: {
      attribute: "#F15623",
      background: "rgba(241,86,35,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      212:[1,2,3,4,5,6],
      213:[1,2,3,4,5,6],
      214:[1,2,3,4,5,6],
      215:[1,2,3,4,5,6],
      239:[1,2,3,4,5,6],
      240:[1,2,3,4,5,6],
      241:[1,2,3,4,5,6],
      242:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Argonauts",
    frName: "Argonauts",
    fullName: "Toronto Argonauts",
    homeTeamSlug: "toronto-argonauts",
    type: "CFL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#5F8FB1",
      background: "rgba(95,143,177,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      106:[1,2,3,4,5,6],
      107:[1,2,3,4,5,6],
      108:[1,2,3,4,5,6],
      109:[1,2,3,4,5,6],
      121:[1,2,3,4,5,6],
      122:[1,2,3,4,5,6],
      123:[1,2,3,4,5,6],
      124:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Alouettes",
    frName: "Alouettes",
    fullName: "Montreal Alouettes",
    homeTeamSlug: "montreal-alouettes",
    type: "CFL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#0B1F51",
      background: "rgba(11,31,81,0.15)",
    },
    category: 'Teams',
    minSeats: 2,
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Redblacks",
    frName: "Rouge et Noir",
    fullName: "Ottawa Redblacks",
    homeTeamSlug: "ottawa-redblacks",
    type: "CFL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#AC1F2D",
      background: "rgba(172,31,45,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      D:[1,2,3,4,5,6],
      E:[1,2,3,4,5,6],
      F:[1,2,3,4,5,6],
      R:[1,2,3,4,5,6],
      S:[1,2,3,4,5,6],
      T:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Roughriders",
    frName: "Roughriders",
    fullName: "Saskatchewan Roughriders",
    homeTeamSlug: "saskatchewan-roughriders",
    type: "CFL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#00623f",
      background: "rgba(0, 98, 63,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      312:[1,2,3,4,5,6],
      313:[1,2,3,4,5,6],
      314:[1,2,3,4,5,6],
      315:[1,2,3,4,5,6],
      316:[1,2,3,4,5,6],
      317:[1,2,3,4,5,6],
      237:[1,2,3,4,5,6],
      238:[1,2,3,4,5,6],
      239:[1,2,3,4,5,6],
      240:[1,2,3,4,5,6],
      241:[1,2,3,4,5,6],
      113:[1,2,3,4,5,6],
      114:[1,2,3,4,5,6],
      115:[1,2,3,4,5,6],
      116:[1,2,3,4,5,6],
      117:[1,2,3,4,5,6],
      137:[1,2,3,4,5,6],
      138:[1,2,3,4,5,6],
      139:[1,2,3,4,5,6],
      140:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Tiger-Cats",
    frName: "Tiger-Cats",
    fullName: "Hamilton Tigercats",
    homeTeamSlug: "hamilton-tigercats",
    type: "CFL",
    zones: ["Upper Zone", "Premium Zone", "Lower Zone"],
    colors: {
      attribute: "#FFB819",
      background: "rgba(255,184,25,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      103:[1,2,3,4,5,6],
      104:[1,2,3,4,5,6],
      105:[1,2,3,4,5,6],
      106:[1,2,3,4,5,6],
      107:[1,2,3,4,5,6],
      113:[1,2,3,4,5,6],
      114:[1,2,3,4,5,6],
      115:[1,2,3,4,5,6],
      116:[1,2,3,4,5,6],
      117:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Grey Cup",
    frName: "Coupe Grey",
    fullName: "Grey Cup",
    homeTeamSlug: "grey-cup",
    type: "CFL",
    zones: ["Lower Zone", "Other", "-"],
    colors: {
      attribute: "#d60000",
      background: "rgba(214,0,0,0.1)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      E: [1,2,3,4,5,6],
      F: [1,2,3,4,5,6],
      G: [1,2,3,4,5,6],
      R: [1,2,3,4,5,6],
      S: [1,2,3,4,5,6],
      T: [1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5]
  },
  {
    name: "Wranglers",
    frName: "Wranglers",
    fullName: "Calgary Wranglers",
    homeTeamSlug: "calgary-wranglers",
    type: "AHL",
    zones: ["Press Level", "Second Level", "Lower Bowl"],
    colors: {
      attribute: "#C2273D",
      background: "rgba(206, 14, 45,0.3)",
    },
    category: 'Teams',
  },
  {
    name: "Moose",
    frName: "Moose",
    fullName: "Manitoba Moose",
    homeTeamSlug: "manitoba-moose",
    type: "AHL",
    zones: ["Upper Zone", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#004c97",
      background: "rgba(0, 76, 151, 0.3)",
    },
    category: 'Teams',
    minSeats: 2,
  },
  {
    name: "Belleville Senators",
    frName: "Sénateurs de Belleville",
    fullName: "Belleville Senators",
    homeTeamSlug: "belleville-senators",
    type: "AHL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#E3173E",
      background: "rgba(227, 23, 62, 0.1)",
    },
    category: 'Teams',
    minSeats: 2,
  },
  {
    name: "Toronto Marlies",
    frName: "Marlies de Toronto",
    fullName: "Toronto Marlies",
    homeTeamSlug: "toronto-marlies",
    type: "AHL",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#003E7E",
      background: "rgba(0, 62, 126, 0.1)",
    },
    category: 'Teams',
    minSeats: 2,
  },
  {
    name: "Laval Rocket",
    frName: "Rocket de Laval",
    fullName: "Laval Rocket",
    homeTeamSlug: "laval-rocket",
    type: "AHL",
    zones: ["Upper Zone", "Lower Zone", "-"],
    colors: {
      attribute: "#001E61",
      background: "rgba(0, 30, 97, 0.1)",
    },
    category: 'Teams',
    minSeats: 2,
  },
  {
    name: "Hamilton Hammers",
    frName: "Hammers de Hamilton",
    fullName: "Hamilton Hammers",
    homeTeamSlug: "hamilton-hammers",
    type: "AHL",
    zones: ["Upper Zone", "Lower Zone", "-"],
    colors: {
      attribute: "#000000",
      background: "rgba(0, 0, 0, 0.1)",
    },
    category: 'Teams',
    minSeats: 2,
  },
  {
    name: "Abbotsford Canucks",
    frName: "Canucks d'Abbotsford",
    fullName: "Abbotsford Canucks",
    homeTeamSlug: "abbotsford-canucks",
    type: "AHL",
    zones: ["-", "-", "Lower Zone"],
    colors: {
      attribute: "#047835",
      background: "rgba(4, 120, 53,0.3)",
    },
    category: 'Teams',
    minSeats: 1,
  },
  {
    name: "Whitecaps FC",
    frName: "Whitecaps FC",
    fullName: "Vancouver Whitecaps FC",
    homeTeamSlug: "vancouver-whitecaps-fc",
    type: "MLS",
    zones: ["General Admission", "Middle Zone", "Lower Zone"],
    colors: {
      attribute: "#9DC2EA",
      background: "rgba(157, 194, 234, 0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      212:[1,2,3,4,5,6],
      213:[1,2,3,4,5,6],
      214:[1,2,3,4,5,6],
      215:[1,2,3,4,5,6],
      239:[1,2,3,4,5,6],
      240:[1,2,3,4,5,6],
      241:[1,2,3,4,5,6],
      242:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Toronto FC",
    frName: "Toronto FC",
    fullName: "Toronto FC",
    homeTeamSlug: "toronto-fc",
    type: "MLS",
    zones: ["Upper Zone", "Lower Zone", "Other"],
    colors: {
      attribute: "#B81137",
      background: "rgba(184, 17, 55, 0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    allowedRowsBySection: {
      106:[1,2,3,4,5,6],
      107:[1,2,3,4,5,6],
      108:[1,2,3,4,5,6],
      109:[1,2,3,4,5,6],
      121:[1,2,3,4,5,6],
      122:[1,2,3,4,5,6],
      123:[1,2,3,4,5,6],
      124:[1,2,3,4,5,6],
    },
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "CF Montréal",
    frName: "CF Montréal",
    fullName: "CF Montréal",
    homeTeamSlug: "montreal-fc",
    type: "MLS",
    zones: ["Lower Zone", "Premium Zone", "-"],
    colors: {
      attribute: "#0C2149",
      background: "rgba(12, 33, 73, 0.3)",
    },
    category: 'Teams',
    minSeats: 2,
    bypassPreferredForSets: [2, 3, 4, 5],
  },
  {
    name: "Hitmen",
    frName: "Hitmen",
    fullName: "Calgary Hitmen",
    homeTeamSlug: "calgary-hitmen",
    type: "WHL",
    zones: ["Press Level", "Second Level", "Lower Bowl"],
    colors: {
      attribute: "#D42604",
      background: "rgba(212,38,4,0.3)",
    },
    category: 'Teams',
    minSeats: 0,
  },
  {
    name: "Roughnecks",
    frName: "Roughnecks",
    fullName: "Calgary Roughnecks",
    homeTeamSlug: "calgary-roughnecks",
    type: "NLL",
    zones: ["Press Level", "Second Level", "Lower Bowl"],
    colors: {
      attribute: "#D42604",
      background: "rgba(212,38,4,0.3)",
    },
    category: 'Teams',
    minSeats: 0,
  },
  {
    name: "UFC Fight Night",
    frName: "UFC Fight Night",
    fullName: "UFC Fight Night",
    homeTeamSlug: "ufc-fight-night",
    type: "UFC",
    zones: ["Upper Bowl", "Lower Bowl", "Premium Zone"],
    colors: {
      attribute: "#D42604",
      background: "rgba(212,38,4,0.3)",
    },
    category: 'Teams',
    minSeats: 0,
  },
  {
    name: "Edmonton",
    frName: "Edmonton",
    fullName: "Edmonton",
    homeTeamSlug: "edmonton-wjc",
    type: "IIHF",
    zones: ["Upper Bowl", "Lower Bowl", "Premium Zone"],
    colors: {
      attribute: "#E51937",
      background: "rgba(229,25,55,0.3)",
    },
    category: 'Teams',
    minSeats: 0,
  },
  {
    name: "Red Deer",
    frName: "Red Deer",
    fullName: "Red Deer",
    homeTeamSlug: "red-deer-wjc",
    type: "IIHF",
    zones: ["Upper Zone", "-", "Lower Zone"],
    colors: {
      attribute: "#008852",
      background: "rgba(0,136,82,0.3)",
    },
    category: 'Teams',
    minSeats: 0,
  },

];

export const getTeamsGroupedByLeague = (teams = TEAMS) => {
  const groups = {};
  for (const team of teams) {
    const league = team.type || 'Other';
    if (!groups[league]) {
      groups[league] = [];
    }
    groups[league].push(team);
  }
  return groups;
};

export const TEAMS_BY_LEAGUE = getTeamsGroupedByLeague(TEAMS);

export default TEAMS;

